import React, { useEffect, useState } from "react";
import { getToken, getUser } from "../utils/auth";

function Profile() {
  const [user, setUser] = useState(getUser());
  const [loading, setLoading] = useState(!getUser());

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }

    fetch("http://localhost/jyotish_karmaa_api/profile.php", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    })
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        if (data.success && data.user) {
          setUser(data.user);
          localStorage.setItem("user", JSON.stringify(data.user));
        } else {
          setUser(null);
          console.error(data.message || "Profile fetch failed");
        }
      })
      .catch(err => {
        setUser(null);
        console.error("Profile fetch error:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading profile...</p>;
  if (!user) return <p>No user data found.</p>;

  return (
    <div className="profile-page">
      <h2>My Profile</h2>
      <div className="profile-card">
        <p><strong>Name:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
        {user.phone && <p><strong>Phone:</strong> {user.phone}</p>}
        {user.role && <p><strong>Role:</strong> {user.role}</p>}
      </div>

      <div className="video-access">
        <h3>Exclusive Video</h3>
        <video width="640" controls>
          <source src="/videos/demo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default Profile;
